import { DESKTOP_LARGE, DESKTOP_MEDIUM, DESKTOP, TABLET_L, TABLET_P } from '../constants';

/**
 ************************* フォント **************************
 */
export const DEFAULT_FONT_FAMILY = 'FuturaStd, Helvetica, Arial, sans-serif, Hiragino Sans GB';

/**
 ************************** カラー **************************
 *   *** ルール ***
 *     1. 命名規則
 *         # 無彩色 (灰色は除く)
 *           [色]
 *         # 灰色/有彩色、且つ、パーツの色が同じカラーコードの場合:
 *           [パーツ名]_[色]
 *         # 灰色/有彩色、且つ、パーツの色が異なる場合:
 *           ### 共通で使用されるカラーコードの場合:
 *             [パーツ名]_[色] > COMMON(_序数)
 *           ### 一箇所のみで使用されるカラーコードの場合:
 *             [パーツ名]_[色] > [画面/部品コード] > ([SP/PC]) > ([ファイル名]) の構成で作成する。
 *             * 画面コード (例):
 *               INSPIRATION    : /{locale}/inspiration/*
 *               HAIR_BEAUTY_PRO: /{locale}/salon-consultation/*
 *     2. XD または .psd データの指定色を設定する。
 */
export const BLACK = '#000';
export const WHITE = '#fff';

/** 仕切り線: 灰色 */
export const BORDER_GRAY = Object.freeze({
  COMMON_1: '#959b9f',
  COMMON_2: '#d8d8d8',
  COMMON_3: '#e0e0e0',
  HAIR_BEAUTY_PRO: {
    MODAL: '#dfdfdf',
    SETTING: '#d2dce2',
  },
  INSPIRATION: '#ccc',
});

/** 背景: 灰色 */
export const BG_GRAY = Object.freeze({
  COMMON_1: '#f2f2f2',
  COMMON_2: '#e0e0e0',
  COMMON_3: '#d8d8d8',
  COMMON_4: '#959b9f',
  COMMON_5: '#e0e0e0',
  COMMON_6: '#707070',
  COMMON_7: '#ccc',
  COMMON_8: '#333',
});

/** 背景: 有彩色 */
export const BG_CHROMATIC = Object.freeze({
  COMMON_1: '#8a7973', // スモークブラウン
});

/** テキスト: 灰色 */
export const TEXT_GRAY = Object.freeze({
  COMMON_1: '#d8d8d8',
  COMMON_2: '#959b9f',
  COMMON_3: '#b8193f',
  COMMON_4: '#ccc',
  COMMON_5: '#333',
  COMMON_6: '#282828',
});

/** Placeholder */
export const PLACEHOLDER_GRAY = '#d3d3d3';

/**
 ************************* スクリーンサイズ **************************
 */
export const screenSizes = {
  desktopLarge: DESKTOP_LARGE,
  desktopMedium: DESKTOP_MEDIUM,
  desktop: DESKTOP,
  tabletL: TABLET_L,
  tabletP: TABLET_P,
};

/**
 ************************** その他の定数 ****************************
 */
export const NAVIGATION_DESKTOP_HEIGHT = 133;
export const NAVIGATION_MOBILE_HEIGHT = 60;
export const SCREEN_LOCKUP_HEIGHT = '70vh';
export const SCREEN_LOCKUP_WIDTH = 1060;
export const MOBILE_PADDING = 20;
export const PAGE_WIDTH = 1440;
export const STYLIST_LOCKUP = 600;
export const HAIR_DIAGNOSIS_BUTTONS_HEIGHT = 64;
export const SALON_CONSULTATION_HEADER_HEIGHT_PC = '115px';
export const SALON_CONSULTATION_HEADER_HEIGHT_SP = '90px';
export const SALON_CONSULTATION_NAVIGATION_HEIGHT_PC = '220px';
export const SALON_CONSULTATION_NAVIGATION_HEIGHT_SP = '70px';



// WEBPACK FOOTER //
// ./src/styles/variables.style.js